// extracted by mini-css-extract-plugin
export default {"mobile_code_data":"mobileCodeData_mobile_code_data__3zy6j","loading":"mobileCodeData_loading__TVODc","label":"mobileCodeData_label__1m4++","field":"mobileCodeData_field__drNcL"};